export class BookCoverStyleRequest {
  idBookVersion!: number;
  idBookCoverStyle?: number | null;
  assembledFileName?: string | null;
  coverService?: boolean | null;
}